/* eslint-disable linebreak-style */
import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const fetchEmployeeSuccess = data => ({
  type: actions.FETCH_EMPLOYEE_SUCCESS,
  data,
});

export const fetchEmployee = id => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .get(`/employee/${id}`)
    .then((response) => {
      dispatch(fetchEmployeeSuccess(response.data));
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const updateEmployeeSuccess = data => ({
  type: actions.UPDATE_EMPLOYEE_SUCCESS,
  data,
});

export const updateEmployee = (data, message) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .put('/employee', data)
    .then((response) => {
      // dispatch(updateEmployerSuccess(response.data));
      dispatch(setMessage(message || 'Funcionário atualizado com sucesso'));
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const createEmployeeSuccess = () => ({
  type: actions.CREATE_EMPLOYEE_SUCCESS,
});

export const createEmployee = data => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post('/employee', data)
    .then((response) => {
      dispatch(setMessage('Funcionário cadastrado com sucesso'));
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const createNewEmployee = (data, msg) => (dispatch) => {
  dispatch(setLoading(true));
  const message = msg || 'Funcionário cadastrado com sucesso';
  return axios
    .post('/settings/employees/register/lot', data)
    .then((response) => {
      dispatch(setMessage(message));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const fetchEmployeeConfigs = employeeId => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .get(`settings/employees/${employeeId}`)
    .then((response) => {
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      return Promise.reject(error);
    });
};

export const fetchEmployeesSuccess = employees => ({
  type: actions.FETCH_EMPLOYEES_SUCCESS,
  employees,
});

export const fetchEmployees = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .get('/employee/list')
    .then((response) => {
      dispatch(fetchEmployeesSuccess(response.data));
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const deleteEmployeeSuccess = id => ({
  type: actions.DELETE_EMPLOYEE_SUCCESS,
  id,
});

export const deleteEmployee = id => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .delete(`/employee/${id}`)
    .then(() => {
      dispatch(deleteEmployeeSuccess(id));
      dispatch(setLoading(false));
      dispatch(setMessage('Funcionário excluído com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const applyRestrictionsSuccess = restrictions => ({
  type: actions.APPLY_RESTRICTIONS_SUCCESS,
  restrictions,
});

export const applyRestrictions = restrictions => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post('/employee/options/lot', restrictions)
    .then((response) => {
      dispatch(applyRestrictionsSuccess(response.data));
      dispatch(setLoading(false));
      dispatch(setMessage('Restrições aplicadas com sucesso.'));
      return Promise.resolve();
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject();
    });
};

export const fetchDissmissEmployeeSuccess = data => ({
  type: actions.FETCH_DISMISS_EMPLOYEE_SUCCESS,
  data,
});

export const fetchDissmissEmployee = () => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get('/employee/inactive')
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(fetchDissmissEmployeeSuccess(response.data));
      // return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const cancelDismiss = (id, message) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .delete(`/demission/employee/${id}`)
    .then((response) => {
      dispatch(setMessage(message || 'Cancelamento de desligamento efetuado com sucesso'));
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const dissmissEmployee = (data, message) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post('/demission/employee', data)
    .then((response) => {
      dispatch(setMessage(message || 'Processo de desligamento efetuado com sucesso'));
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

